import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, ScrollText, CookingPot, FileCheck, Search, Sparkles, Download, Eye, Star } from "lucide-react";
import MiniTimer from "@/components/landing/MiniTimer";

const newTools = [
  {
    icon: BookOpen,
    name: "Daily Prayer Activities",
    odia: "ପ୍ରାର୍ଥନା ସଭା କାର୍ଯ୍ୟକ୍ରମ",
    desc: "ସମ୍ପୂର୍ଣ୍ଣ ପ୍ରଭାତୀ ପ୍ରାର୍ଥନା ସଭା — ଖବର, ସୁବିଚାର, ସ୍ବାସ୍ଥ୍ୟ ସୂଚନା, GK ପ୍ରଶ୍ନ, ନୀତିକଥା — ସବୁ Auto Generate!",
    highlight: true,
    tag: "MOST POPULAR",
  },
  {
    icon: ScrollText,
    name: "Nutrition Ladoo Receipt",
    odia: "ପୋଷଣ ଲାଡୁ ରସିଦ",
    desc: "Nutrition Ladoo ପ୍ରସ୍ତୁତି ପାଇଁ ସମ୍ପୂର୍ଣ୍ଣ ingredient receipt — ତୁରନ୍ତ generate କରନ୍ତୁ",
    highlight: false,
    tag: "NEW",
  },
  {
    icon: CookingPot,
    name: "Ladoo Making Receipt",
    odia: "ଲାଡୁ ତିଆରି ରସିଦ",
    desc: "Student count ଅନୁସାରେ Ladoo ତିଆରି ପାଇଁ exact quantity ଓ receipt ତୁରନ୍ତ ready",
    highlight: false,
    tag: "NEW",
  },
  {
    icon: FileCheck,
    name: "Instant CL Generator",
    odia: "ତୁରନ୍ତ CL ଜେନେରେଟର",
    desc: "Casual Leave application ଗୋଟିଏ click ରେ generate — format ମନେ ରଖିବା ଦରକାର ନାହିଁ",
    highlight: false,
    tag: "NEW",
  },
  {
    icon: Search,
    name: "LO Code Finder",
    odia: "LO କୋଡ୍ ସନ୍ଧାନକାରୀ",
    desc: "Learning Outcome Code ତୁରନ୍ତ ଖୋଜନ୍ତୁ — Class ଓ Subject select କଲେ LO Code ଦେଖାଇଦିଏ",
    highlight: false,
    tag: "NEW",
  },
];

export default function NewToolsShowcaseSection({ downloadLink }) {
  return (
    <section data-testid="new-tools-showcase-section" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        {/* Header */}
        <div className="flex items-center justify-center gap-2 mb-3">
          <Sparkles className="w-5 h-5 text-orange-500" />
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wide">Brand New</span>
        </div>
        <h2
          data-testid="new-tools-headline"
          className="text-3xl md:text-4xl font-bold text-slate-900 text-center leading-tight"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          ନୂଆ Tools ଆସିଗଲା — <span className="text-green-700">ଆଉ ଅଧିକ ସମୟ ବଞ୍ଚାନ୍ତୁ!</span>
        </h2>
        <p className="mt-3 text-center text-slate-600 text-sm md:text-base max-w-2xl mx-auto">
          ଶିକ୍ଷକମାନଙ୍କ ଅନୁରୋଧ ଅନୁସାରେ ଆମେ ନୂଆ ନୂଆ tools ଯୋଡ଼ୁଛୁ। ଏହି tools ଆପଣଙ୍କ daily school work କୁ <strong className="text-green-700">ଆହୁରି ସହଜ</strong> କରିଦେବ।
        </p>

        {/* PDF Preview - Daily Prayer Activities showcase */}
        <div className="mt-10 max-w-2xl mx-auto">
          <Card data-testid="prayer-showcase-card" className="border-2 border-green-200 overflow-hidden shadow-xl">
          <div className="bg-green-700 px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-white" />
              <span className="text-white font-bold text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Daily Prayer Activities — Live Preview
              </span>
            </div>
            <span className="bg-yellow-400 text-slate-900 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase">
              Most Used
            </span>
          </div>
            <CardContent className="p-0">
              {/* Screenshots gallery */}
              <div className="relative">
                <div className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}>
                  <div className="snap-center flex-shrink-0 w-full">
                    <img
                      src="https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/15tu6chp_%E0%AC%AC%E0%AC%BF%E0%AC%A6%E0%AD%8D%E0%AD%9F%E0%AC%BE%E0%AC%B3%E0%AD%9F-%E0%AC%AA%E0%AD%8D%E0%AC%B0%E0%AC%BE%E0%AC%B0%E0%AD%8D%E0%AC%A5%E0%AC%A8%E0%AC%BE-%E0%AC%B8%E0%AC%AD%E0%AC%BE-03-13-2026_06_09_PM.png"
                      alt="Daily Prayer Activities - Page 1"
                      className="w-full h-auto"
                      data-testid="prayer-screenshot-1"
                      loading="lazy"
                    />
                  </div>
                  <div className="snap-center flex-shrink-0 w-full">
                    <img
                      src="https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/w5ssa5t6_%E0%AC%AC%E0%AC%BF%E0%AC%A6%E0%AD%8D%E0%AD%9F%E0%AC%BE%E0%AC%B3%E0%AD%9F-%E0%AC%AA%E0%AD%8D%E0%AC%B0%E0%AC%BE%E0%AC%B0%E0%AD%8D%E0%AC%A5%E0%AC%A8%E0%AC%BE-%E0%AC%B8%E0%AC%AD%E0%AC%BE-03-13-2026_06_09_PM%20%281%29.png"
                      alt="Daily Prayer Activities - Page 2"
                      className="w-full h-auto"
                      data-testid="prayer-screenshot-2"
                      loading="lazy"
                    />
                  </div>
                </div>
                {/* Swipe hint */}
                <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 bg-black/60 text-white text-[10px] font-medium px-3 py-1 rounded-full backdrop-blur-sm">
                  <Eye className="w-3 h-3" />
                  <span>Swipe to see full preview</span>
                  <span className="ml-1">1/2</span>
                </div>
              </div>

              <div className="px-5 pb-5 pt-3">
                <div className="bg-green-50 rounded-xl border border-green-200 p-4 text-center">
                  <p className="text-sm font-bold text-slate-900 mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    ଏହି ସମ୍ପୂର୍ଣ୍ଣ ପ୍ରାର୍ଥନା ସଭା App ରୁ Auto Generate ହୁଏ!
                  </p>
                  <p className="text-xs text-slate-500">
                    ଖବର, ସୁବିଚାର, ସ୍ବାସ୍ଥ୍ୟ ସୂଚନା, GK ପ୍ରଶ୍ନ, ନୀତିକଥା — ସବୁ ଆଜିର ତାରିଖ ଅନୁସାରେ fresh content
                  </p>
                  <div className="flex items-center justify-center gap-1 mt-2">
                    {[1,2,3,4,5].map(s => (
                      <Star key={s} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />
                    ))}
                    <span className="text-xs text-slate-500 ml-1">ସବୁଠୁ ଲୋକପ୍ରିୟ tool</span>
                  </div>
                </div>

                {/* High conversion hook */}
                <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2.5 text-center">
                  <p className="text-xs font-bold text-amber-800">
                    ପ୍ରତିଦିନ ସକାଳେ 10 ମିନିଟ୍ ରେ ସମ୍ପୂର୍ଣ୍ଣ ପ୍ରାର୍ଥନା ସଭା ready — ଆଉ HM ଙ୍କୁ ଲେଖି ଦେବାକୁ ପଡ଼ିବ ନାହିଁ!
                  </p>
                </div>

                <Button
                  data-testid="prayer-download-btn"
                  asChild
                  className="mt-3 w-full h-11 bg-green-700 hover:bg-green-800 text-white rounded-lg font-bold shadow-md"
                >
                  <a href={downloadLink} target="_blank" rel="noopener noreferrer">
                    <Download className="mr-2 w-4 h-4" />
                    ଏହି Tool ପାଇଁ App Download କରନ୍ତୁ
                  </a>
                </Button>
                <a
                  href="https://teacherutilitytoolkit.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="prayer-try-online-btn"
                  className="mt-2 w-full h-10 inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white rounded-lg font-bold text-sm shadow-md transition-all"
                >
                  ⚡ ବିନା Download ଏଠାରେ ଚଲାନ୍ତୁ!
                </a>
                <div className="mt-2 flex justify-center">
                  <MiniTimer />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* New tools grid */}
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-3xl mx-auto">
          {newTools.map((tool, i) => (
            <Card
              key={i}
              data-testid={`new-tool-card-${i}`}
              className={`overflow-hidden transition-all ${
                tool.highlight
                  ? "border-2 border-green-400 shadow-md bg-green-50"
                  : "border border-slate-200 bg-white hover:border-green-200"
              }`}
            >
              <CardContent className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                    tool.highlight ? "bg-green-200" : "bg-orange-50"
                  }`}>
                    <tool.icon className={`w-5 h-5 ${tool.highlight ? "text-green-700" : "text-orange-500"}`} />
                  </div>
                  <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ${
                    tool.tag === "MOST POPULAR"
                      ? "bg-green-700 text-white"
                      : "bg-orange-100 text-orange-600"
                  }`}>
                    {tool.tag}
                  </span>
                </div>
                <h3 className="font-bold text-slate-900 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  {tool.name}
                </h3>
                <p className="text-xs text-green-600 font-medium">{tool.odia}</p>
                <p className="mt-1.5 text-xs text-slate-500 leading-relaxed">{tool.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Psychological hook */}
        <div className="mt-8 text-center">
          <p className="text-sm text-slate-600 max-w-lg mx-auto">
            ଆମେ ପ୍ରତି ମାସରେ <strong className="text-green-700">ନୂଆ tools</strong> ଯୋଡ଼ୁଛୁ। Premium ନେଲେ ସବୁ ନୂଆ tools <strong className="text-green-700">FREE ରେ unlock</strong> ହୋଇଯିବ — ଆଲଗା ପଇସା ଦେବାକୁ ପଡ଼ିବ ନାହିଁ!
          </p>
          <Button
            data-testid="new-tools-download-btn"
            asChild
            className="mt-4 h-12 px-8 bg-green-700 hover:bg-green-800 text-white rounded-full text-base font-semibold shadow-lg shadow-green-900/20"
          >
            <a href={downloadLink} target="_blank" rel="noopener noreferrer">
              <Download className="mr-2 w-4 h-4" />
              Download & Try New Tools
            </a>
          </Button>
          <div className="mt-3">
            <a
              href="https://teacherutilitytoolkit.in/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="newtools-try-online-btn"
              className="inline-flex items-center gap-2 h-11 px-6 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white rounded-full text-sm font-bold shadow-lg shadow-orange-500/25 transition-all"
            >
              ⚡ ବିନା Download ସବୁ Tools ଏଠାରେ ଚଲାନ୍ତୁ!
            </a>
          </div>
          <div className="mt-2 flex justify-center">
            <MiniTimer />
          </div>
        </div>
      </div>
    </section>
  );
}
